export const LoginDivider: React.FC = () => {
  return (
    <div className="separator">
      <h4>OR</h4>
    </div>
  );
};
